// src/components/Sidebar/MobileTopBar.jsx
//
// Cabecera móvil para las pantallas que no tienen `PageHeader` —Home, Zeno—:
// hamburguesa a un lado, búsqueda y la acción propia de la pantalla al otro.
// Es el equivalente del rail: lo que en escritorio está siempre a la vista en
// la columna izquierda, aquí está siempre a la vista arriba.
//
// Sin marca. Llevaba el isotipo y la palabra "Zenit", y decirle a alguien en
// qué app está mientras la está usando no es información: son 130px del ancho
// más escaso que hay puestos en repetir lo que ya sabe.
//
// Reclama el hueco de cabecera igual que `PageHeader`, así que mientras esté
// montada el shell no dibuja su hamburguesa flotante. Es la misma regla de
// siempre: la pinta quien esté arriba del todo, y sólo uno.
//
// Va pegajosa porque la barra de abajo también lo está. Con la de arriba en el
// flujo normal, bajar dos pantallas dejaba el menú —y con él Zeno, Shop,
// Knowledge y la cuenta— sin forma de abrirse hasta volver al principio.
import React from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import MobileMenuButton from "./MobileMenuButton";
import { useHeaderSlot } from "./MobileNavContext";
import { useCommandPalette } from "../CommandPalette/CommandPaletteContext";
import { cn } from "../../lib/utils";

export function MobileTopBar({ action, className }) {
  const { t } = useTranslation();
  const isPrimaryHeader = useHeaderSlot();
  const { openPalette } = useCommandPalette();

  return (
    <div
      className={cn(
        "sticky top-0 z-40 flex items-center gap-3 px-4 py-3 md:hidden",
        "border-b border-white/5 bg-black/80 backdrop-blur-xl",
        className
      )}
    >
      {isPrimaryHeader && <MobileMenuButton />}

      {/* La búsqueda vive donde vive en escritorio: en el cromo persistente.
          El rail la lleva arriba del todo y se oculta por debajo de `md`, así
          que sin esto ⌘K —que en un teléfono no existe como atajo— sólo se
          alcanzaría abriendo el cajón. Es un icono y no un campo a propósito:
          un campo aquí sería otra vez el segundo buscador que Home quitó. */}
      <div className="ml-auto flex shrink-0 items-center gap-2">
        <button
          type="button"
          onClick={openPalette}
          aria-label={t("palette.open", "Search")}
          className={cn(
            "inline-flex h-11 w-11 items-center justify-center rounded-2xl",
            "border border-white/12 bg-white/[0.06] text-white/70 transition",
            "active:bg-white/[0.16] active:text-white",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/70"
          )}
        >
          <Search className="h-5 w-5" />
        </button>
        {action}
      </div>
    </div>
  );
}

export default MobileTopBar;
